import { css, SerializedStyles } from '@emotion/react';

import { Theme } from '@shipengine/giger-theme';

export const getIconStyles = (theme: Theme): SerializedStyles => {
    return css({
        marginRight: theme.spacing() / 2,
    });
};
